// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type ShrnaDropDownListQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ShrnaDropDownListInput>;
}>;


export type ShrnaDropDownListQuery = { __typename?: 'Query', getShrnaDropDownList: { __typename?: 'ShrnaSpecifications', physicalMaterial?: Array<{ __typename?: 'ShrnaPhysicalMaterial', noSelection?: string | null, GLYCEROL?: string | null, DNA?: string | null, VIRUS?: string | null } | null> | null, amount?: Array<{ __typename?: 'Amount', one?: string | null, ten?: string | null, twentyFive?: string | null, hundred?: string | null } | null> | null, titer?: Array<{ __typename?: 'Titer', powerof6?: string | null, powerof7?: string | null, powerof8?: string | null, powerof9?: string | null } | null> | null, volume?: Array<{ __typename?: 'Volume', pointTwo?: string | null, pointOne?: string | null, volOne?: string | null, volTwo?: string | null, volFive?: string | null, volTen?: string | null } | null> | null, aliquot?: Array<{ __typename?: 'Aliquot', Mul1X200?: string | null, Mul2X100?: string | null, Mul4X50?: string | null, Mul8X25?: string | null, Mul5X20?: string | null, Mul2X50?: string | null, Mul4X25?: string | null, Mul5X200?: string | null, Mul10X100?: string | null, Mul20X50?: string | null, Mul40X25?: string | null, Mul25X200?: string | null, Mul50X100?: string | null, Mul100X50?: string | null, Mul200X25?: string | null, Mul10X200?: string | null, Mul20X100?: string | null, Mul40X50?: string | null, Mul80X25?: string | null, Mul50X20?: string | null, Mul100X20?: string | null, Mul10X20?: string | null } | null> | null, vector?: Array<{ __typename?: 'ShrnaVector', pLKO1?: string | null, CMVNeo?: string | null, hPGKNeo?: string | null, CMVtGFP?: string | null, hPGKNeoCMVtGFP?: string | null, hPGKPuroCMVtGFP?: string | null } | null> | null, serverError?: { __typename?: 'ServerError', key?: string | null, value?: string | null } | null } };


export const ShrnaDropDownListDocument = gql`
    query shrnaDropDownList($input: ShrnaDropDownListInput) {
  getShrnaDropDownList(input: $input) {
    physicalMaterial {
      noSelection
      GLYCEROL
      DNA
      VIRUS
    }
    amount {
      one
      ten
      twentyFive
      hundred
    }
    titer {
      powerof6
      powerof7
      powerof8
      powerof9
    }
    volume {
      pointTwo
      pointOne
      volOne
      volTwo
      volFive
      volTen
    }
    aliquot {
      Mul1X200
      Mul2X100
      Mul4X50
      Mul8X25
      Mul5X20
      Mul2X50
      Mul4X25
      Mul5X200
      Mul10X100
      Mul20X50
      Mul40X25
      Mul25X200
      Mul50X100
      Mul100X50
      Mul200X25
      Mul10X200
      Mul20X100
      Mul40X50
      Mul80X25
      Mul50X20
      Mul100X20
      Mul10X20
    }
    vector {
      pLKO1
      CMVNeo
      hPGKNeo
      CMVtGFP
      hPGKNeoCMVtGFP
      hPGKPuroCMVtGFP
    }
    serverError {
      key
      value
    }
  }
}
    `;
export type ShrnaDropDownListComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ShrnaDropDownListQuery, ShrnaDropDownListQueryVariables>, 'query'>;

    export const ShrnaDropDownListComponent = (props: ShrnaDropDownListComponentProps) => (
      <ApolloReactComponents.Query<ShrnaDropDownListQuery, ShrnaDropDownListQueryVariables> query={ShrnaDropDownListDocument} {...props} />
    );
    

/**
 * __useShrnaDropDownListQuery__
 *
 * To run a query within a React component, call `useShrnaDropDownListQuery` and pass it any options that fit your needs.
 * When your component renders, `useShrnaDropDownListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShrnaDropDownListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShrnaDropDownListQuery(baseOptions?: Apollo.QueryHookOptions<ShrnaDropDownListQuery, ShrnaDropDownListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShrnaDropDownListQuery, ShrnaDropDownListQueryVariables>(ShrnaDropDownListDocument, options);
      }
export function useShrnaDropDownListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShrnaDropDownListQuery, ShrnaDropDownListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShrnaDropDownListQuery, ShrnaDropDownListQueryVariables>(ShrnaDropDownListDocument, options);
        }
export function useShrnaDropDownListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShrnaDropDownListQuery, ShrnaDropDownListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShrnaDropDownListQuery, ShrnaDropDownListQueryVariables>(ShrnaDropDownListDocument, options);
        }
export type ShrnaDropDownListQueryHookResult = ReturnType<typeof useShrnaDropDownListQuery>;
export type ShrnaDropDownListLazyQueryHookResult = ReturnType<typeof useShrnaDropDownListLazyQuery>;
export type ShrnaDropDownListSuspenseQueryHookResult = ReturnType<typeof useShrnaDropDownListSuspenseQuery>;
export type ShrnaDropDownListQueryResult = Apollo.QueryResult<ShrnaDropDownListQuery, ShrnaDropDownListQueryVariables>;